import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AccountVoipFormData } from '../../interfaces/communication.interface';

@Injectable({ providedIn: 'root' })
export class AccountVoipService {
  private apiUrl = environment.apiURL + 'account-voips';

  constructor(private http: HttpClient) {}

  getLines(params: any = {}): Observable<any> {
    let httpParams = new HttpParams();
    if (params.page) httpParams = httpParams.set('page', params.page.toString());
    if (params.pageSize) httpParams = httpParams.set('pageSize', params.pageSize.toString());
    return this.http.get(this.apiUrl, { params: httpParams });
  }

  getLine(reference: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${reference}`);
  }

  createLine(data: AccountVoipFormData): Observable<any> {
    return this.http.post(`${this.apiUrl}/new`, data);
  }

  updateLine(reference: string, data: Partial<AccountVoipFormData>): Observable<any> {
    return this.http.put(`${this.apiUrl}/${reference}/update`, data);
  }

  deleteLine(reference: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${reference}/delete`);
  }

  testConnection(reference: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/${reference}/test-connection`, {});
  }

  syncWebhooks(reference: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/${reference}/sync-webhooks`, {});
  }
}
